var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"china-map-page"},[_c('div',{ref:"chinaMap",staticClass:"map-content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }